import { Pattern3 } from './data';
import { s } from './Pattern.styles';
import SpecialPatternOption from './SpecialOptionBox';
import { usePatternContext } from '../../../../context/PatternContext';
interface Props {
  savePattern: () => void;
  pattern3: Pattern3;
  setPattern3: (pattern: Pattern3) => void;
  isEditMode?: boolean;
  upDatePattern: () => void;
}

const SpecialPattern = () => {
  const handlePatternChange = (key: string) => {
    setPattern3({ ...pattern3, [key]: 'N' });
  };
  const { pattern3, setPattern3, isEditMode } = usePatternContext();
  const handleReset = () => {
    setPattern3({
      specialConditionOption: 'C',
      hugCondition: 'N',
      tenantsOpposition: 'N',
      wageBond: 'N',
      resale: 'N',
      violatingBuilding: 'N',
      statutoryLandRights: 'N',
      graveSiteRights: 'N',
      lien: 'N',
    });
  };

  return (
    <s.PatternBoxContainer>
      <s.TitleBox>
        <div>특수 알고리즘</div>
        <div>
          <span>선택</span>
        </div>
      </s.TitleBox>
      <s.PatterBoxInner>
        <SpecialPatternOption pattern={pattern3} setPattern={setPattern3} />
      </s.PatterBoxInner>
    </s.PatternBoxContainer>
  );
};

export default SpecialPattern;
